module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/64764c0e8dd11a31d0141c93ccb48a70.png";